import Vue from 'vue'
import Vuex from 'vuex'
import { getImageUrl, setImageUrl, getAccessId, setAccessId, getUserName, setUserName, getUserPhone, setUserPhone, getDeliveryAddress, setDeliveryAddress } from '../util/auth'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		accessId: getAccessId(),
		userName: getUserName(),
		userPhone: getUserPhone(),
		deliveryAddress: getDeliveryAddress(),
		imageUrl: getImageUrl()
	},
	actions: {
		setAccessId ({ commit }, accessId) {
			commit('SET_ACCESSID', accessId)
		},
		setUserName ({ commit }, userName) {
			commit('SET_USERNAME', userName)
		},
		setUserPhone ({ commit }, userPhone) {
			commit('SET_USERPHONE', userPhone)
		},
		setDeliveryAddress ({ commit }, deliveryAddress) {
			commit('SET_DELIVERYADDRESS', deliveryAddress)
		},
		setImageUrl ({ commit }, imageUrl) {
			commit('SET_IMAGEURL', imageUrl)
		}
	},
	mutations: {
		SET_ACCESSID: (state, accessId) => {
			state.accessId = accessId
			setAccessId(accessId)
		},
		SET_USERNAME: (state, userName) => {
			state.userName = userName
			setUserName(userName)
		},
		SET_USERPHONE: (state, userPhone) => {
			state.userPhone = userPhone
			setUserPhone(userPhone)
		},
		SET_DELIVERYADDRESS: (state, deliveryAddress) => {
			state.deliveryAddress = deliveryAddress
			setDeliveryAddress(deliveryAddress)
		},
		SET_IMAGEURL: (state, imageUrl) => {
			state.imageUrl = imageUrl
			setImageUrl(imageUrl)
		}
	},
	getters: {
		id: state => state.accessId,
		imageUrl: state => state.imageUrl
	}
})
